import { Map, fromJS } from 'immutable'
import * as actions from './actions'

export const initialState = Map()

export default function (state = initialState, action) {
  //
  const {
    type: actionType,
    payload,
  } = action

  switch (actionType) {
    //
    case actions.AMBASSADORS_SET_PAYOUT: {
      const { data } = payload
      return state.set('payouts', fromJS(data))
        .set('processing', false)
    }

    default:
      return state
  }
}

